import { ensureRepositoryQueryDataFactory as ensureRepositoryQueryDataFactoryGeneric } from '@mews/framework';
import { RepositoryRegistry } from '../createRegistry';

export const ensureRepositoryQueryDataFactory = ensureRepositoryQueryDataFactoryGeneric<RepositoryRegistry>;

export type EnsureRepositoryQueryData = ReturnType<typeof ensureRepositoryQueryDataFactory>;
